const LoadingOverlay = (props) => {


    return (
        <div id="loading-overlay" className="hide">
            <div className="book-loader-container">
                <svg id="book-load" data-name="book-load" xmlns="http://www.w3.org/2000/svg" width="369.33" height="355.25"
                    viewBox="0 0 369.33 355.25">
                    <g id="outline">
                        <path id="page3" className="cls-2"
                            d="M184.84,137.25C104.65,77.91,42.61,96.88,42.61,96.88v202.66c80.93-13.02,142.06,41.71,142.06,41.71,0,0,61.13-54.73,142.06-41.71V96.88s-61.7-18.97-141.89,40.38Z" />
                        <path id="bind"
                            d="M204.27,337.19c.29.9.44,1.83.44,2.79,0,7.33-8.96,13.27-20.01,13.27s-20.01-5.94-20.01-13.27c0-.92.14-1.81.41-2.67" />
                        <path id="page2"
                            d="M326.73,124.51c14.01,1.33,20.22,3.8,20.22,3.8v192.31s-99.65-16.3-162.28,20.64h0c-62.64-36.94-162.28-20.6-162.28-20.6v-192.31s6.21-2.47,20.22-3.8" />
                        <path id="page1"
                            d="M346.95,154.71c8.63.91,20.38,4.84,20.38,4.84v182.42s-79.31-24.86-182.67-.71h0c-103.35-24.15-182.67.75-182.67.75v-182.42s11.75-3.93,20.38-4.84" />
                        <line id="spine" x1="184.49" y1="341.25" x2="184.84" y2="137.25" />
                    </g>
                    <g id="book-flip" data-name="book-flip">
                        <path id="page3-r" d="M184.67,341.25s61.13-54.73,142.06-41.71V96.88s-61.7-18.97-141.89,40.38" />
                        <path id="page3-l"
                            d="M184.84,137.25C104.65,77.91,42.61,96.88,42.61,96.88v202.66c80.93-13.02,142.06,41.71,142.06,41.71" />
                        <path id="d" d="M184.49,341.25c-37.46-79.11-93.32-111.04-93.32-111.04V18.85s51.66,35.19,93.67,118.4" />
                        <path id="c" d="M184.49,341.25c-12.47-91.49-49.67-126.64-49.67-126.64V5.32s42.79,48.87,50.01,131.93" />
                        <path id="b" d="M184.49,341.25c12.47-91.49,50.36-126.64,50.36-126.64V5.32s-42.79,48.87-50.01,131.93" />
                        <path id="a" d="M185.19,341.25c37.46-79.11,93.32-111.04,93.32-111.04V18.85s-51.66,35.19-93.67,118.4" />
                    </g>
                    <g id="book-bg" data-name="book-bg">
                        <path id="bg" className="cls-1"
                            d="M326.9,124.13c14.01,1.33,20.22,3.8,20.22,3.8v26.4c8.63.91,20.38,4.84,20.38,4.84v182.42s-79.31-24.86-182.67-.71h0c-103.35-24.15-182.67.75-182.67.75v-182.42s11.75-3.93,20.38-4.84v-26.4s6.21-2.47,20.22-3.8v-27.66s62.04-18.97,142.23,40.38c80.19-59.35,141.89-40.38,141.89-40.38,0,0,0,27.63,0,27.63Z" />
                    </g>
                </svg>
            </div>
        </div>
    )

    /*
    return (
        <div id="loading-overlay" className="hide" role="dialog" aria-label="loading graphic">
            <div className="loading-body">
                <div className="bl loader"></div>
            </div>
        </div>
    )
    */

}

export default LoadingOverlay;